var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"baseModal",attrs:{"id":"careerModal","size":"sm","hide-header":"","hide-footer":"","content-class":"custom-modal-content","no-close-on-backdrop":true,"no-close-on-esc":true}},[_c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center h-100"},[_c('p',{staticClass:"modal-title text-center mb-4",domProps:{"innerHTML":_vm._s(_vm.modalText)}}),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"btn custom-btn",style:({
            backgroundColor: '#fffff',
            borderRadius: '2px',
            color: '#3c3c3c',
            borderColor: '#3c3c3c',
            padding: '10px',
          }),on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n          キャンセル\n        ")]),_c('button',{staticClass:"btn custom-btn",style:({
            backgroundColor: '#EB5757',
            borderRadius: '2px',
            color: '#fff',
            borderColor: '#EB5757',
            padding: '10px',
          }),on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v("\n          "+_vm._s(_vm.buttonText)+"\n        ")])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }